import { render, staticRenderFns } from "./PlayerChatBlockComplaints.vue?vue&type=template&id=6cc12dc1&"
import script from "./PlayerChatBlockComplaints.vue?vue&type=script&lang=js&"
export * from "./PlayerChatBlockComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports